module.exports = __webpack_public_path__ + "img/pms_7.a5f8ed30.png";